import { TypographyTypeTokens, } from '@voltmoney/schema';
import React, { memo } from 'react';
import { TypographyBase } from './Typography.base';
import ThemeProvider from '@voltmoney/theme';
import { TypographyBaseDLS } from "./TypographyDLS.base";
/**
 * Primary UI component for user interaction
 */
const Typography = ({ type = TypographyTypeTokens.DEFAULT, id, typeDLS, ...props }) => {
    /**
     *  logic -> base-component(...props)
     * */
    const theme = ThemeProvider.getTheme();
    const typographyThemeProps = theme.typography[type];
    if (typeDLS) {
        return (React.createElement(TypographyBaseDLS, { id: id, typeDLS: typeDLS, ...typographyThemeProps, ...props }));
    }
    return (React.createElement(TypographyBase, { id: id, ...typographyThemeProps, ...props }));
};
export default memo(Typography);
export { Typography };
